(function () {
  var PROP_NAME = 'properties[Pickle flavour]';

  function picker() {
    return document.querySelector('.ph-pickle-choice');
  }

  function pickerIsActive() {
    var box = picker();
    if (!box) return false;
    if (box.hasAttribute('hidden')) return false;
    return true;
  }

  function selectedRadio() {
    return document.querySelector('input[name="ph-pickle-choice"]:checked');
  }

  function selectedValue() {
    if (!pickerIsActive()) return '';
    var radio = selectedRadio();
    return radio && !radio.disabled ? radio.value : '';
  }

  function currentVariantId() {
    var input = document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
    return input && input.value ? String(input.value) : '';
  }

  function is2LtrVariant(id) {
    var box = picker();
    if (!box) return false;
    var ids = ',' + (box.getAttribute('data-ph-2ltr-ids') || '') + ',';
    return ids.indexOf(',' + String(id) + ',') !== -1;
  }

  function modal() {
    return document.querySelector('[data-ph-pickle-modal]');
  }

  function fillConfetti(layer) {
    if (!layer) return;
    layer.innerHTML = '';
    var colors = ['#7c4dff', '#ffca28', '#66bb6a', '#ef5350', '#42a5f5', '#ff7043', '#26c6da'];
    for (var i = 0; i < 46; i++) {
      var piece = document.createElement('span');
      piece.className = 'ph-pickle-modal__piece';
      piece.style.left = Math.random() * 100 + '%';
      piece.style.background = colors[i % colors.length];
      piece.style.width = 5 + Math.random() * 6 + 'px';
      piece.style.height = 8 + Math.random() * 8 + 'px';
      piece.style.setProperty('--drift', Math.random() * 80 - 40 + 'px');
      piece.style.animationDuration = 2.4 + Math.random() * 2.4 + 's';
      piece.style.animationDelay = Math.random() * 1.6 + 's';
      piece.style.transform = 'rotate(' + Math.random() * 180 + 'deg)';
      layer.appendChild(piece);
    }
  }

  var closeTimer;

  function openModal() {
    var box = modal();
    if (!box) return;
    box.classList.remove('is-open');
    fillConfetti(box.querySelector('[data-ph-pickle-confetti]'));
    box.removeAttribute('hidden');
    window.requestAnimationFrame(function () {
      box.classList.add('is-open');
    });
    document.documentElement.style.overflow = 'hidden';
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(closeModal, 5000);
  }

  function closeModal() {
    var box = modal();
    if (!box) return;
    window.clearTimeout(closeTimer);
    box.classList.remove('is-open');
    box.setAttribute('hidden', '');
    var layer = box.querySelector('[data-ph-pickle-confetti]');
    if (layer) layer.innerHTML = '';
    document.documentElement.style.overflow = '';
  }

  var phPickleReady = false;
  var phWas2Ltr = false;

  function setPickerVisible(show) {
    var box = picker();
    if (!box) return;
    if (show) box.removeAttribute('hidden');
    else box.setAttribute('hidden', '');
    box.querySelectorAll('input[name="ph-pickle-choice"]').forEach(function (el) {
      el.disabled = !show;
    });
    if (!show) {
      closeModal();
      document.querySelectorAll('input[data-ph-pickle-prop]').forEach(function (el) {
        el.remove();
      });
    }
  }

  function syncVisibility() {
    var box = picker();
    if (!box || box.getAttribute('data-ph-pickle-when') !== '2ltr') {
      syncPickleIntoForms();
      return;
    }
    var show = is2LtrVariant(currentVariantId());
    setPickerVisible(show);
    if (phPickleReady && show && !phWas2Ltr) openModal();
    phPickleReady = true;
    phWas2Ltr = show;
    syncPickleIntoForms();
  }

  function ensureHidden(form) {
    if (!form) return;
    var input = form.querySelector('input[data-ph-pickle-prop]');
    var value = selectedValue();
    if (!value) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = PROP_NAME;
      input.setAttribute('data-ph-pickle-prop', '1');
      form.appendChild(input);
    }
    input.value = value;
  }

  function syncPickleIntoForms() {
    if (!document.querySelector('input[name="ph-pickle-choice"]')) return;
    document.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(ensureHidden);
  }

  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest('[data-ph-pickle-modal-close]')) {
      closeModal();
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });
  document.addEventListener('change', function (event) {
    if (!event.target) return;
    if (event.target.name === 'ph-pickle-choice') {
      syncPickleIntoForms();
      return;
    }
    if (event.target.name === 'id' || event.target.closest('variant-radios-detail') || event.target.closest('variant-group-detail')) {
      syncVisibility();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncVisibility);
  } else {
    syncVisibility();
  }

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = '';
    if (typeof input === 'string') url = input;
    else if (input && input.url) url = input.url;

    var value = selectedValue();
    if (value && url.indexOf('/cart/add') !== -1 && init && init.body instanceof FormData) {
      init.body.set(PROP_NAME, value);
    }

    if (value && url.indexOf('/cart/add') !== -1 && init && typeof init.body === 'string') {
      try {
        var payload = JSON.parse(init.body);
        payload.properties = payload.properties || {};
        payload.properties['Pickle flavour'] = value;
        init = Object.assign({}, init, { body: JSON.stringify(payload) });
      } catch (err) {
        /* ignore non-JSON bodies */
      }
    }

    return originalFetch.call(this, input, init);
  };

  window.phSyncPickleChoice = syncPickleIntoForms;
  window.phGetPickleChoice = selectedValue;
})();
